import { useEffect, useState } from "react";

import { Box, Divider, Grid } from "@mantine/core";

import { Bank, BankSpecificResponse, BankCreditNoteResponse, NoteType, DocLanguage } from "types";

import { BankCommentsSection } from "./bank-comments-section";
import { DetailsSection } from "./details-section";
import { NotesSection } from "./notes-section";
import { RequestInfoSection } from "./request-info-section";

interface BankTabProps {
  bank: Bank;
  bankCreditRequestId: number;
  bankSpecific?: BankSpecificResponse;
  bankNotes: BankCreditNoteResponse[];
  processingNotes: BankCreditNoteResponse[];
  onAddNote: (note: string, noteType: NoteType) => void;
  onSaveRequestInfo: (requestNumber: string, collaboratorName: string) => void;
  onDocLanguageChange: (language: DocLanguage) => void;
}

export const BankTab = ({ bank, bankCreditRequestId, bankSpecific, bankNotes, processingNotes, onAddNote, onSaveRequestInfo, onDocLanguageChange }: BankTabProps) => {
  const [requestNumber, setRequestNumber] = useState(bankSpecific?.requestNumber || "");
  const [collaboratorName, setCollaboratorName] = useState(bankSpecific?.collaboratorName || "");

  useEffect(() => {
    setRequestNumber(bankSpecific?.requestNumber || "");
    setCollaboratorName(bankSpecific?.collaboratorName || "");
  }, [bankSpecific?.requestNumber, bankSpecific?.collaboratorName]);

  const handleSaveOnBlur = () => {
    onSaveRequestInfo(requestNumber, collaboratorName);
  };

  return (
    <Box>
      <Grid gutter="md">
        <Grid.Col span={4}>
          <DetailsSection
            bankCreditRequestId={bankCreditRequestId}
            docLanguage={bankSpecific?.docLanguage}
            onDocLanguageChange={onDocLanguageChange}
          />
        </Grid.Col>

        <Grid.Col span={4}>
          <NotesSection type="BANK" notes={bankNotes} onAddNote={(note) => onAddNote(note, "BANK")} />
        </Grid.Col>

        <Grid.Col span={4}>
          <NotesSection type="PROCESSING" notes={processingNotes} onAddNote={(note) => onAddNote(note, "PROCESSING")} />
        </Grid.Col>
      </Grid>

      <Divider my="md" />

      <Box
        p="md"
        style={{
          backgroundColor: "rgba(241, 242, 244, 1)",
          borderRadius: 12,
          border: "1px solid rgba(50, 51, 67, 0.15)",
        }}
      >
        <RequestInfoSection
          requestNumber={requestNumber}
          collaboratorName={collaboratorName}
          onRequestNumberChange={setRequestNumber}
          onCollaboratorNameChange={setCollaboratorName}
          onRequestNumberBlur={handleSaveOnBlur}
          onCollaboratorNameBlur={handleSaveOnBlur}
        />

        <Divider my="md" />

        <BankCommentsSection bank={bank} bankCreditRequestId={bankCreditRequestId} />
      </Box>
    </Box>
  );
};
